exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-200[data-v-01635ad0]{width:200px!important}", ""]);

// exports
